import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import { AuthContext } from "../../contexts/AuthContext";

function HomeInicio() {
  // const { isAuth } = useContext(AuthContext);

  const navigate = useNavigate();

  // function handleClick() {
  //   navigate("/login");
  // }
  return (
    <>
      <Header />
      <div className="imgContainer">
        <img
          src="/logoInstitucion.png"
          alt="auto"
          className="imgLogo"
        />
      </div>
    </>
  );
}

export default HomeInicio;
